import { render, staticRenderFns } from "./agv-customer-sidebar.vue?vue&type=template&id=34bf6e9e&scoped=true&lang=pug&"
import script from "./agv-customer-sidebar.vue?vue&type=script&lang=js&"
export * from "./agv-customer-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./agv-customer-sidebar.vue?vue&type=style&index=0&id=34bf6e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf6e9e",
  null
  
)

export default component.exports